import { useRoutes, Navigate } from "react-router-dom";
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import Header from "./components/header";
import User from "./components/user";
import { AuthProvider, useAuth } from "./contexts/authContext";
import GenerateAIPage from "./components/pages/GenerateAIPage";
import CustomerSelectionPage from "./components/pages/CustomerSelectionPage";
import Costing from "./components/costing/Costing";
import { DarkModeProvider } from "./contexts/darkModeContext"; 




// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { userLoggedIn, loading } = useAuth();

  // Wait for the authentication state to load
  if (loading) {
    return <div>Loading...</div>; // Optionally replace with a spinner
  }

  // Redirect to login if not authenticated
  if (!userLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  const routesArray = [
    { path: "/login", element: <Login /> },
    { path: "/register", element: <Register /> },
    
    {
      path: "/user",
      element: (
        <ProtectedRoute>
          <User />
        </ProtectedRoute>
      ),
    },
    {
      path: "/home",
      element: (
        <ProtectedRoute>
          <CustomerSelectionPage />
        </ProtectedRoute>
      ),
    },

    {
      path: "/generate-ai",
      element: (
        <ProtectedRoute>
          <GenerateAIPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/costing",
      element: (
        <ProtectedRoute>
          <Costing />
        </ProtectedRoute>
      ),
    },
    // Catch-all route to avoid redirect loop
    { path: "*", element: <Navigate to="/login" replace /> },
  ];

  const routesElement = useRoutes(routesArray);

  return (
    <AuthProvider>
      <DarkModeProvider> {/* 👈 wrap everything in DarkModeProvider */}
        <Header />
        <div className="w-full h-screen flex flex-col bg-white text-black dark:bg-gray-900 dark:text-white">
          {routesElement}
        </div>
      </DarkModeProvider>
    </AuthProvider>
  );
  
}

export default App;